<template>
  <div class="card product-card">
    <div class="card-img-container" @click="$emit('goToProducts')">
      <img
        :src="getCategoryImage(productCategory.name_d)"
        :alt="'Kategori: ' + productCategory.name_d"
        class="card-img"
      />
    </div>
    <div>
      <p class="product-type">
        {{ productCategory.name_d }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["goToProducts"],
  props: ["productCategory"],
  methods: {
    getCategoryImage(name) {
      const images = this.$store.state.products.categoryImages;
      //Deafult is placeholder
      let fileName = "chemistry-icon.svg";
      if (images.length > 0) {
        images.forEach((image) => {
          if (name) {
            if (name.toLowerCase().includes(image.category)) {
              //Update fileName if there's a match in Vuex store categoryImages
              fileName = image.fileName;
            }
          }
        });
      }
      return require("/src/assets/category-images/" + fileName);
    },
  },
};
</script>

<style></style>
